import { connect } from 'react-redux'
import { setWizards } from 'core/components/wizard/actions'
import { setConfigurator } from '../actions'
import BrandsList from './BrandsList'

const mapStateToProps = state => ({
  wizards: state.wizards,
  configurator: state.configurator,
  configuration: state.configuration
})

const mapDispatchToProps = {
  setWizards,
  setConfigurator
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BrandsList)
